import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons'


const BotonCheckAtri = ({index,onClickSuma,onClickResta,atributo, activo, categoria}) => {

	return (
			<div>
				{activo ?
					<button className="btnCardPedido naranja" onClick={onClickResta(index, atributo)}>
						<FontAwesomeIcon icon={faCheckCircle} size="2x"/>
					</button>
				:
					<button className="btnCardPedido check" onClick={onClickSuma(index, atributo, categoria)}>
						<FontAwesomeIcon icon={faCircle} size="2x"/>
					</button>
				}
			</div>
);
	
}



export default BotonCheckAtri